import { Button, Center, Group, Stack, Text, Title } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";

import { SecureTokenManager } from "@utils/auth/secureTokenManager";
import TestDashboardNav from "../test_controller/dashboard/TestDashboardNav";
import { getPreferredTestModeUrl } from "@utils/testModeStorage";
import { useTranslation } from "react-i18next";

type NotFoundVariant = "notFound" | "noAccess";

interface NotFoundPageProps {
  variant?: NotFoundVariant;
}

export default function NotFoundPage({ variant = "notFound" }: NotFoundPageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAuthenticated = SecureTokenManager.isAuthenticated();
  const homePath = isAuthenticated ? getPreferredTestModeUrl() : "/";

  return (
    <>
      {isAuthenticated && <TestDashboardNav />}
      <Center mih={isAuthenticated ? "70vh" : "100vh"} px="md">
        <Stack align="center" gap="xs" maw={480}>
          <Text fz={64} fw={700} lh={1} c="dimmed">
            {variant === "noAccess" ? "403" : "404"}
          </Text>
          <Title order={2} ta="center">
            {t(`notFound.${variant}Title`)}
          </Title>
          <Text ta="center" c="dimmed">
            {t(`notFound.${variant}Description`)}
          </Text>
          <Group mt="md">
            <Button variant="default" onClick={() => navigate(-1)}>
              {t("notFound.goBack")}
            </Button>
            <Button component={Link} to={homePath}>
              {isAuthenticated ? t("notFound.goToDashboard") : t("notFound.goHome")}
            </Button>
          </Group>
        </Stack>
      </Center>
    </>
  );
}
